// Environment configuration
// This file determines which endpoint to use based on the build environment

const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
const isLocalDevelopment = hostname === 'localhost' ||
  hostname === '127.0.0.1' ||
  hostname.startsWith('192.168.')
const isDevelopmentSite = hostname === 'dev.yutnori.app'

const config = {
  localDevelopment: {
    SOCKET_ENDPOINT: `http://${hostname || 'localhost'}:5000`,
    ENABLE_LOGGING: true,
    ANALYTICS_ENVIRONMENT: 'localhost'
  },
  development: {
    SOCKET_ENDPOINT: 'https://yut-game-server-dev-6734615ef53a.herokuapp.com/',
    ENABLE_LOGGING: true,
    ANALYTICS_ENVIRONMENT: 'dev'
  },
  production: {
    SOCKET_ENDPOINT: 'https://yoot-game-6c96a9884664.herokuapp.com/',
    ENABLE_LOGGING: true,
    ANALYTICS_ENVIRONMENT: 'prod'
  }
};

const environment = isLocalDevelopment
  ? 'localDevelopment'
  : isDevelopmentSite
    ? 'development'
    : 'production'

export const SOCKET_ENDPOINT = config[environment].SOCKET_ENDPOINT;
export const ENABLE_LOGGING = config[environment].ENABLE_LOGGING;
export const ANALYTICS_ENVIRONMENT = config[environment].ANALYTICS_ENVIRONMENT;
export const IS_PRODUCTION = environment === 'production';
export const IS_DEV = environment !== 'production';